module.exports = __webpack_public_path__ + "img/speed.e41b760d.png";